export const getCustomSignupDetails = (state) => state.customSignup.details;
export const getIsCustomSignupDetailsFetching = (state) =>
  state.customSignup.isFetching;
